import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Checklist } from '../../../classes/checklist';
import { ChecklistService } from '../../../services/checklist';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {Contract} from "../../../classes/contract";
import {ContractFounder} from "../../../classes/contractFounder";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ContractService} from "../../../services/contract";
import {ContractFounderService} from "../../../services/contractFounder";
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";
import {ContractFounderCreateModalComponent} from "../../../modals/contract/contract-founder-create-modal.component";

@Component({
  selector: 'app-contract-update',
  templateUrl: './contract-update.component.html',
  styleUrls: ['./contract-update.component.css']
})
export class ContractUpdateComponent implements OnInit {

    contract = new Contract();
    contractUpdateResult = true;

    checklists: Array<Checklist> = [];
    contractFounders: Array<ContractFounder> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private contractService: ContractService,
              private contractFounderService: ContractFounderService,
              private checklistService: ChecklistService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.contractService.getByID(params.get('id'))
        .subscribe({
          next: (contract: any) => {
            this.contract = contract;
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
    });

      this.checklistService.getAll()
          .pipe(
              switchMap((checklistsData: any) => from(checklistsData))
          )
          .subscribe({
              next: (checklist: any) => {
                  this.checklists.push(checklist);
              },
              error: e => {
                  console.log('Error: ' + e);
              }
          });

      this.contractFounderService.getAll()
          .pipe(
              switchMap((contractFoundersData: any) => from(contractFoundersData))
          )
          .subscribe({
              next: (contractFounder: any) => {
                  this.contractFounders.push(contractFounder);
              },
              error: e => {
                  console.log('Error: ' + e);
              }
          });
  }

    openContracFounderCreateModal() {
        const modalRef = this.modalService.open(ContractFounderCreateModalComponent);
        modalRef.result.then((contract: Contract) => {
            if (contract.name) {
                this.contractFounderService.create(contract)
                    .subscribe({
                        next: (contractCreated: any) => {
                            this.contractFounders.push(contractCreated);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

  onSubmit() {
    this.contractService.update(this.contract)
      .subscribe({
        next: () => {
          this.router.navigate(['/contract/' + this.contract.id_contract]);
        },
        error: (err: HttpErrorResponse) => {
          this.contractUpdateResult = false;
          console.log(err);
        }
      });
  }

}
